import { render, staticRenderFns } from "./IrInvoiceChargeMetadata.vue?vue&type=template&id=2854049e&scoped=true&"
import script from "./IrInvoiceChargeMetadata.vue?vue&type=script&lang=js&"
export * from "./IrInvoiceChargeMetadata.vue?vue&type=script&lang=js&"
import style0 from "./IrInvoiceChargeMetadata.vue?vue&type=style&index=0&id=2854049e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2854049e",
  null
  
)

export default component.exports